// ======================================================================
// FILE:
// src/modules/finance/services/profitLossService.js
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// FEATURE:
// Profit & Loss
//
// PURPOSE:
// Frontend API client for Profit & Loss report.
//
// IMPORTANT:
// - API calls only
// - No React code
// - No UI logic
// - No navigation
// ======================================================================

import axiosClient
from "../../../api/axiosClient";

// ======================================================================
// BASE URL
// ======================================================================

const BASE_URL =
"/api/finance/profit-loss";

// ======================================================================
// GET PROFIT & LOSS
// ======================================================================

async function getProfitLoss(
params = {}
) {

    const response =
        await axiosClient.get(
            BASE_URL,
            {
                params,
            }
        );

    return response.data.data;
}

// ======================================================================
// EXPORT
// ======================================================================

const profitLossService = {

    getProfitLoss,

};

export default profitLossService;